module.exports = __webpack_public_path__ + "static/media/C18_page_05.551488a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/C18_page_05.mp4
// module id = 2RIf
// module chunks = 0